import {getDateDDMMYYUtc} from "./timestampService";

export function compareDate(dateA, dateB) {
    return getDateDDMMYYUtc(dateA) === getDateDDMMYYUtc(dateB)
}
